module.exports = __webpack_public_path__ + "img/app-window.aed95cb6.png";